/**
 * WEBM.
 *
 * @group DRM
 *
 * @beta
 */
export const WEBM = 'webm';
//# sourceMappingURL=WEBM.js.map